import React, { Component } from "react";
import {
  Button,
  Container,
  Row,
  Form,
  Col,
  Card,
  Badge,
  Alert,
  ProgressBar,
  Table,
  Modal,
} from "react-bootstrap";
import { toast } from "react-toastify";
import configData from "../config.json";

import LoadingOverlay from "./LoadingOverlay";
export default class TableRuleTriggerWizard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      currentStep: 1,
      totalSteps: 5,
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),

      // Step 1: Table Selection
      tables: [],
      selectedTable: "",
      triggerEvents: ["insert", "update", "delete"],
      selectedTriggerEvent: "",

      // Step 2: Rule Selection
      availableRules: [],
      selectedRule: "",
      ruleDetails: {},

      // Step 3: Trigger Configuration
      priority: "1",
      isActive: "Yes",
      conditions: "",
      conditionBuilder: {
        field: "",
        operator: "=",
        value: "",
      },
      operators: [
        "=",
        "!=",
        ">",
        "<",
        ">=",
        "<=",
        "contains",
        "not_contains",
        "is_null",
        "is_not_null",
      ],

      // Step 4: Testing
      testData: {},
      testResults: null,
      testLoading: false,

      // Step 5: Review & Save
      configuration: {},
      saveLoading: false,

      // Common
      errors: {},
      loading: false,
      tableColumns: [],
      testDataText: "", // Store raw text input for test data
    };
  }

  componentDidMount() {
    this.getTables();
    this.getAvailableRules();
  }

  showToast = (msg, type) => {
    var tType = toast.TYPE.INFO;
    if (type === "success") tType = toast.TYPE.SUCCESS;
    if (type === "error") tType = toast.TYPE.ERROR;
    if (type === "warning") tType = toast.TYPE.WARNING;
    toast(msg, { type: tType });
  };

  // API Calls
  getTables = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "/masters/gettables", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ tables: data.tables });
        }
      })
      .catch((error) => {
        console.error("Error fetching tables:", error);
        this.showToast("Failed to load tables", "error");
      });
  };

  getAvailableRules = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Table_rule_triggers/getAvailableRules", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ availableRules: data.rules });
        }
      })
      .catch((error) => {
        console.error("Error fetching rules:", error);
        this.showToast("Failed to load rules", "error");
      });
  };

  getTableColumns = (tableName) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("tableName", tableName);
    fetch(configData.api_url + "/masters/getcolumns", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ tableColumns: data.columns });
        }
      })
      .catch((error) => {
        console.error("Error fetching columns:", error);
        this.showToast("Failed to load table columns", "error");
      });
  };

  // Navigation
  nextStep = () => {
    if (this.validateCurrentStep()) {
      this.setState({ currentStep: this.state.currentStep + 1 });
    }
  };

  prevStep = () => {
    this.setState({ currentStep: this.state.currentStep - 1 });
  };

  validateCurrentStep = () => {
    const { currentStep } = this.state;
    let isValid = true;
    let errors = {};

    switch (currentStep) {
      case 1:
        if (!this.state.selectedTable) {
          errors.selectedTable = "Please select a table";
          isValid = false;
        }
        if (!this.state.selectedTriggerEvent) {
          errors.selectedTriggerEvent = "Please select a trigger event";
          isValid = false;
        }
        break;
      case 2:
        if (!this.state.selectedRule) {
          errors.selectedRule = "Please select a rule";
          isValid = false;
        }
        break;
      case 3:
        if (!this.state.priority) {
          errors.priority = "Please set priority";
          isValid = false;
        }
        break;
      default:
        break;
    }

    this.setState({ errors });
    if (!isValid) {
      this.showToast("Please fix the errors before proceeding", "error");
    }
    return isValid;
  };

  // Event handlers
  handleTableSelect = (e) => {
    const tableName = e.target.value;
    this.setState({ selectedTable: tableName });
    if (tableName) {
      this.getTableColumns(tableName);
    }
  };

  handleRuleSelect = (e) => {
    const ruleId = e.target.value;
    const ruleDetails = this.state.availableRules.find(
      (rule) => rule.rulesdef_Id === ruleId
    );
    this.setState({
      selectedRule: ruleId,
      ruleDetails: ruleDetails || {},
    });
  };

  handleConditionChange = (field, value) => {
    this.setState({
      conditionBuilder: {
        ...this.state.conditionBuilder,
        [field]: value,
      },
    });
  };

  addCondition = () => {
    const { conditionBuilder } = this.state;
    if (
      conditionBuilder.field &&
      conditionBuilder.operator &&
      conditionBuilder.value
    ) {
      const newCondition = {
        field: conditionBuilder.field,
        operator: conditionBuilder.operator,
        value: conditionBuilder.value,
      };

      const currentConditions = this.state.conditions
        ? JSON.parse(this.state.conditions)
        : [];
      currentConditions.push(newCondition);

      this.setState({
        conditions: JSON.stringify(currentConditions),
        conditionBuilder: { field: "", operator: "=", value: "" },
      });
    }
  };

  removeCondition = (index) => {
    const currentConditions = JSON.parse(this.state.conditions);
    currentConditions.splice(index, 1);
    this.setState({
      conditions: JSON.stringify(currentConditions),
    });
  };

  testRuleTrigger = () => {
    // Validate wizard configuration before testing
    if (
      !this.state.selectedTable ||
      !this.state.selectedTriggerEvent ||
      !this.state.selectedRule
    ) {
      this.showToast("Please complete steps 1-3 before testing", "warning");
      return;
    }

    // Validate JSON before testing
    if (!this.state.testDataText.trim()) {
      this.showToast(
        "Please enter test data first or generate sample JSON",
        "warning"
      );
      return;
    }

    try {
      JSON.parse(this.state.testDataText);
    } catch (error) {
      this.showToast(
        "Please fix JSON format before testing: " + error.message,
        "error"
      );
      return;
    }

    this.setState({ testLoading: true });

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("tableName", this.state.selectedTable);
    formData.append("triggerEvent", this.state.selectedTriggerEvent);
    formData.append("ruleId", this.state.selectedRule);
    formData.append("conditions", this.state.conditions);
    formData.append("priority", this.state.priority);
    formData.append("testData", this.state.testDataText);
    formData.append("recordId", "1");
    formData.append("testMode", "wizard"); // Indicate this is a wizard test

    fetch(
      configData.api_url + "C_Table_rule_triggers/testWizardConfiguration",
      {
        method: "POST",
        mode: "cors",
        body: formData,
      }
    )
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          testResults: data,
          testLoading: false,
        });
        if (data.status === "success") {
          this.showToast(
            "Rule configuration test completed successfully",
            "success"
          );
        } else {
          this.showToast(
            "Rule configuration test failed: " + data.message,
            "error"
          );
        }
      })
      .catch((error) => {
        console.error("Test error:", error);
        this.setState({ testLoading: false });
        this.showToast("Failed to test rule configuration", "error");
      });
  };

  saveTriggerConfiguration = () => {
    this.setState({ saveLoading: true });

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("table_name", this.state.selectedTable);
    formData.append("rule_id", this.state.selectedRule);
    formData.append("rule_name", this.state.ruleDetails.name || "");
    formData.append("trigger_event", this.state.selectedTriggerEvent);
    formData.append("priority", this.state.priority);
    formData.append("is_active", this.state.isActive);
    formData.append("conditions", this.state.conditions);

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + "C_Table_rule_triggers/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({ saveLoading: false });
        if (data.status === "success") {
          this.showToast("Table rule trigger created successfully", "success");
          this.handleClose();
        } else {
          this.showToast("Failed to create trigger: " + data.message, "error");
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Save error:", error);
        this.setState({ saveLoading: false });
        this.showToast("Failed to save trigger configuration", "error");
      
        this.setState({ loading: false });});
  };

  // Modal handlers
  handleShow = () => {
    this.setState({ show: true });
  };

  handleClose = () => {
    this.setState({
      show: false,
      currentStep: 1,
      selectedTable: "",
      selectedTriggerEvent: "",
      selectedRule: "",
      ruleDetails: {},
      priority: "1",
      isActive: "Yes",
      conditions: "",
      conditionBuilder: { field: "", operator: "=", value: "" },
      testData: {},
      testDataText: "",
      testResults: null,
      errors: {},
    });
  };

  // Generate sample JSON based on selected table columns
  generateSampleJson = () => {
    if (!this.state.selectedTable || this.state.tableColumns.length === 0) {
      this.showToast(
        "Please select a table first and wait for columns to load",
        "warning"
      );
      return;
    }

    const sampleData = {};
    const tableName = this.state.selectedTable;

    // Add primary key based on table name
    const primaryKeyName = tableName + "_Id";
    sampleData[primaryKeyName] = 1;

    // Generate sample data for each column
    this.state.tableColumns.forEach((column, index) => {
      const columnInfo =
        typeof column === "string" ? { name: column, type: "varchar" } : column;
      const columnName = columnInfo.name || column;
      const columnType = columnInfo.type || "varchar";

      if (
        columnName.toLowerCase().includes("id") &&
        columnName !== primaryKeyName
      ) {
        // Foreign key IDs
        sampleData[columnName] = 1;
      } else if (columnName.toLowerCase().includes("email")) {
        sampleData[columnName] = "test@example.com";
      } else if (columnName.toLowerCase().includes("phone")) {
        sampleData[columnName] = "+1234567890";
      } else if (columnName.toLowerCase().includes("name")) {
        sampleData[columnName] = "Sample Name";
      } else if (columnName.toLowerCase().includes("date")) {
        sampleData[columnName] = "2024-11-01 12:00:00";
      } else if (
        columnName.toLowerCase().includes("amount") ||
        columnName.toLowerCase().includes("total") ||
        columnName.toLowerCase().includes("price")
      ) {
        sampleData[columnName] = "100.00";
      } else if (columnName.toLowerCase().includes("status")) {
        sampleData[columnName] = "active";
      } else if (columnName.toLowerCase().includes("description")) {
        sampleData[columnName] = "Sample description text";
      } else if (columnType.toLowerCase().includes("int")) {
        sampleData[columnName] = 1;
      } else if (
        columnType.toLowerCase().includes("decimal") ||
        columnType.toLowerCase().includes("float")
      ) {
        sampleData[columnName] = "10.50";
      } else if (columnType.toLowerCase().includes("bool")) {
        sampleData[columnName] = true;
      } else {
        // Default string value
        sampleData[columnName] = "sample_value";
      }
    });

    // Add some common fields that might not be in table columns
    if (this.state.selectedTriggerEvent === "insert") {
      sampleData["createdBy"] = 1;
      sampleData["createdOn"] = "2024-11-01 12:00:00";
    } else if (this.state.selectedTriggerEvent === "update") {
      sampleData["updatedBy"] = 1;
      sampleData["updatedOn"] = "2024-11-01 12:00:00";
    }

    const sampleJsonText = JSON.stringify(sampleData, null, 2);
    this.setState({
      testData: sampleData,
      testDataText: sampleJsonText,
    });
    this.showToast(
      "Sample JSON generated based on " + tableName + " table structure",
      "success"
    );
  };

  // Clear test data
  clearTestData = () => {
    this.setState({
      testData: {},
      testDataText: "",
    });
    this.showToast("Test data cleared", "info");
  };

  // Validate JSON format
  validateJson = () => {
    if (!this.state.testDataText.trim()) {
      this.showToast("Please enter some test data first", "warning");
      return;
    }

    try {
      const parsed = JSON.parse(this.state.testDataText);
      this.setState({ testData: parsed });
      this.showToast("JSON is valid! ✓", "success");
    } catch (error) {
      this.showToast("Invalid JSON format: " + error.message, "error");
    }
  };

  // Render methods
  renderStepHeader = () => {
    const { currentStep, totalSteps } = this.state;
    const progress = (currentStep / totalSteps) * 100;

    const stepTitles = {
      1: "Select Table & Trigger",
      2: "Choose Rule",
      3: "Configure Trigger",
      4: "Test Configuration",
      5: "Review & Save",
    };

    return (
      <div className="mb-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5>
            Step {currentStep} of {totalSteps}: {stepTitles[currentStep]}
          </h5>
          <Badge bg="primary">{Math.round(progress)}% Complete</Badge>
        </div>
        <ProgressBar now={progress} />
      </div>
    );
  };

  renderStep1 = () => {
    return (
      <Card>
        <Card.Header>
          <h6>Select Table and Trigger Event</h6>
        </Card.Header>
        <Card.Body>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Select Table</Form.Label>
                <Form.Select
                  value={this.state.selectedTable}
                  onChange={this.handleTableSelect}
                  isInvalid={!!this.state.errors.selectedTable}
                >
                  <option value="">Choose a table...</option>
                  {this.state.tables.map((table, index) => (
                    <option key={index} value={table}>
                      {table}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {this.state.errors.selectedTable}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Trigger Event</Form.Label>
                <Form.Select
                  value={this.state.selectedTriggerEvent}
                  onChange={(e) =>
                    this.setState({ selectedTriggerEvent: e.target.value })
                  }
                  isInvalid={!!this.state.errors.selectedTriggerEvent}
                >
                  <option value="">Choose trigger event...</option>
                  {this.state.triggerEvents.map((event, index) => (
                    <option key={index} value={event}>
                      {event.toUpperCase()}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {this.state.errors.selectedTriggerEvent}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          {this.state.selectedTable && (
            <Alert variant="info">
              <strong>Selected:</strong> Rules will execute automatically when{" "}
              {this.state.selectedTriggerEvent} operations occur on the{" "}
              <strong>{this.state.selectedTable}</strong> table.
            </Alert>
          )}
        </Card.Body>
      </Card>
    );
  };

  renderStep2 = () => {
    return (
      <Card>
        <Card.Header>
          <h6>Choose Rule to Associate</h6>
        </Card.Header>
        <Card.Body>
          <Row className="mb-3">
            <Col md={12}>
              <Form.Group>
                <Form.Label>Available Rules</Form.Label>
                <Form.Select
                  value={this.state.selectedRule}
                  onChange={this.handleRuleSelect}
                  isInvalid={!!this.state.errors.selectedRule}
                >
                  <option value="">Choose a rule...</option>
                  {this.state.availableRules.map((rule, index) => (
                    <option key={index} value={rule.rulesdef_Id}>
                      {rule.name} - {rule.description}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {this.state.errors.selectedRule}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          {this.state.ruleDetails.name && (
            <Alert variant="info">
              <strong>Rule Details:</strong>
              <br />
              <strong>Name:</strong> {this.state.ruleDetails.name}
              <br />
              <strong>Description:</strong> {this.state.ruleDetails.description}
              <br />
              <strong>Input Parameters:</strong>{" "}
              {this.state.ruleDetails.ruleinputparameters}
              <br />
              <strong>Output Parameters:</strong>{" "}
              {this.state.ruleDetails.ruleoutputparameters}
            </Alert>
          )}
        </Card.Body>
      </Card>
    );
  };

  renderStep3 = () => {
    const currentConditions = this.state.conditions
      ? JSON.parse(this.state.conditions)
      : [];

    return (
      <Card>
        <Card.Header>
          <h6>Configure Trigger Settings</h6>
        </Card.Header>
        <Card.Body>
          <Row className="mb-3">
            <Col md={4}>
              <Form.Group>
                <Form.Label>Priority</Form.Label>
                <Form.Control
                  type="number"
                  value={this.state.priority}
                  onChange={(e) => this.setState({ priority: e.target.value })}
                  min="1"
                  max="100"
                  isInvalid={!!this.state.errors.priority}
                />
                <Form.Text className="text-muted">
                  Lower numbers = Higher priority
                </Form.Text>
                <Form.Control.Feedback type="invalid">
                  {this.state.errors.priority}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label>Status</Form.Label>
                <Form.Select
                  value={this.state.isActive}
                  onChange={(e) => this.setState({ isActive: e.target.value })}
                >
                  <option value="Yes">Active</option>
                  <option value="No">Inactive</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <hr />

          <h6>Conditions (Optional)</h6>
          <Row className="mb-3">
            <Col md={3}>
              <Form.Group>
                <Form.Label>Field</Form.Label>
                <Form.Select
                  value={this.state.conditionBuilder.field}
                  onChange={(e) =>
                    this.handleConditionChange("field", e.target.value)
                  }
                >
                  <option value="">Choose field...</option>
                  {this.state.tableColumns.map((column, index) => (
                    <option key={index} value={column}>
                      {column}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Operator</Form.Label>
                <Form.Select
                  value={this.state.conditionBuilder.operator}
                  onChange={(e) =>
                    this.handleConditionChange("operator", e.target.value)
                  }
                >
                  {this.state.operators.map((op, index) => (
                    <option key={index} value={op}>
                      {op}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label>Value</Form.Label>
                <Form.Control
                  type="text"
                  value={this.state.conditionBuilder.value}
                  onChange={(e) =>
                    this.handleConditionChange("value", e.target.value)
                  }
                  placeholder="Enter value"
                />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label>&nbsp;</Form.Label>
                <Button
                  variant="primary"
                  onClick={this.addCondition}
                  disabled={
                    !this.state.conditionBuilder.field ||
                    !this.state.conditionBuilder.value
                  }
                  className="d-block"
                >
                  Add
                </Button>
              </Form.Group>
            </Col>
          </Row>

          {currentConditions.length > 0 && (
            <Table striped bordered hover size="sm">
              <thead>
                <tr>
                  <th>Field</th>
                  <th>Operator</th>
                  <th>Value</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentConditions.map((condition, index) => (
                  <tr key={index}>
                    <td>{condition.field}</td>
                    <td>{condition.operator}</td>
                    <td>{condition.value}</td>
                    <td>
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => this.removeCondition(index)}
                      >
                        Remove
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>
    );
  };

  renderStep4 = () => {
    return (
      <Card>
        <Card.Header>
          <h6>Test Configuration</h6>
        </Card.Header>
        <Card.Body>
          <Row className="mb-3">
            <Col md={8}>
              <Form.Group>
                <Form.Label>Test Data (JSON)</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={6}
                  value={this.state.testDataText}
                  onChange={(e) => {
                    this.setState({ testDataText: e.target.value });
                    // Try to parse JSON and update testData state
                    try {
                      const testData = JSON.parse(e.target.value);
                      this.setState({ testData });
                    } catch (error) {
                      // Invalid JSON, keep previous testData
                    }
                  }}
                  placeholder="Enter sample JSON data for testing..."
                />
                <Form.Text className="text-muted">
                  Enter sample data to test the rule execution. JSON must be
                  valid for testing to work.
                </Form.Text>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label>Quick Actions</Form.Label>
                <br />
                <Button
                  variant="outline-primary"
                  size="sm"
                  className="mb-2 w-100"
                  onClick={this.generateSampleJson}
                  disabled={!this.state.selectedTable}
                >
                  Generate Sample JSON
                </Button>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  className="mb-2 w-100"
                  onClick={this.clearTestData}
                >
                  Clear Data
                </Button>
                <Button
                  variant="outline-info"
                  size="sm"
                  className="w-100"
                  onClick={this.validateJson}
                >
                  Validate JSON
                </Button>
                {this.state.selectedTable && (
                  <div className="mt-3">
                    <small className="text-muted">
                      <strong>Selected Table:</strong>{" "}
                      {this.state.selectedTable}
                      <br />
                      <strong>Columns Available:</strong>{" "}
                      {this.state.tableColumns.length}
                    </small>
                  </div>
                )}
              </Form.Group>
            </Col>
          </Row>

          <Button
            variant="primary"
            onClick={this.testRuleTrigger}
            disabled={this.state.testLoading || !this.state.selectedRule}
          >
            {this.state.testLoading
              ? "Testing Configuration..."
              : "🧪 Test Rule Configuration"}
          </Button>

          {this.state.testResults && (
            <Alert
              variant={
                this.state.testResults.status === "success"
                  ? "success"
                  : "danger"
              }
              className="mt-3"
            >
              <strong>Test Results:</strong>
              <br />
              Status: {this.state.testResults.status}
              <br />
              Message: {this.state.testResults.message}
              <br />
              {this.state.testResults.execution_result && (
                <div>
                  <strong>Execution Details:</strong>
                  <pre>
                    {JSON.stringify(
                      this.state.testResults.execution_result,
                      null,
                      2
                    )}
                  </pre>
                </div>
              )}
            </Alert>
          )}
        </Card.Body>
      </Card>
    );
  };

  renderStep5 = () => {
    return (
      <Card>
        <Card.Header>
          <h6>Review & Save Configuration</h6>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={6}>
              <h6>Configuration Summary</h6>
              <Table striped bordered hover size="sm">
                <tbody>
                  <tr>
                    <td>
                      <strong>Table:</strong>
                    </td>
                    <td>{this.state.selectedTable}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Trigger Event:</strong>
                    </td>
                    <td>{this.state.selectedTriggerEvent.toUpperCase()}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Rule:</strong>
                    </td>
                    <td>{this.state.ruleDetails.name}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Priority:</strong>
                    </td>
                    <td>{this.state.priority}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Status:</strong>
                    </td>
                    <td>
                      {this.state.isActive === "Yes" ? "Active" : "Inactive"}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Conditions:</strong>
                    </td>
                    <td>{this.state.conditions ? "Yes" : "None"}</td>
                  </tr>
                </tbody>
              </Table>
            </Col>
            <Col md={6}>
              <h6>What happens next?</h6>
              <Alert variant="info">
                <ul>
                  <li>The rule will be associated with the selected table</li>
                  <li>
                    It will execute automatically on{" "}
                    {this.state.selectedTriggerEvent} operations
                  </li>
                  <li>Conditions will be evaluated before execution</li>
                  <li>All executions will be logged for monitoring</li>
                </ul>
              </Alert>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
  };

  render() {
    const { currentStep, totalSteps } = this.state;

    return (
      <div>
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <Button variant="primary" onClick={this.handleShow}>
          <i className="bi bi-magic me-2"></i>
          Table Rule Trigger Wizard
        </Button>

        <Modal show={this.state.show} onHide={this.handleClose} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Table Rule Trigger Wizard</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.renderStepHeader()}

            {currentStep === 1 && this.renderStep1()}
            {currentStep === 2 && this.renderStep2()}
            {currentStep === 3 && this.renderStep3()}
            {currentStep === 4 && this.renderStep4()}
            {currentStep === 5 && this.renderStep5()}
          </Modal.Body>
          <Modal.Footer>
            {currentStep > 1 && (
              <Button variant="secondary" onClick={this.prevStep}>
                Previous
              </Button>
            )}

            {currentStep < totalSteps && (
              <Button variant="primary" onClick={this.nextStep}>
                Next
              </Button>
            )}

            {currentStep === totalSteps && (
              <Button
                variant="success"
                onClick={this.saveTriggerConfiguration}
                disabled={this.state.saveLoading}
              >
                {this.state.saveLoading ? "Saving..." : "Save Configuration"}
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
